<template>
  <div class="w-full sm:w-290 lg:w-350 h-screen select-none z-10">
    <div
      class="flex flex-col relative sm:fixed overflow-y-auto w-full sm:w-290 lg:w-350 h-screen bg-white dark:bg-dim-900 no-scrollbar-style">
      <div class="relative m-2 hidden xs:block">
        <div class="absolute left-0 text-gray-600 flex items-center pl-4 h-full cursor-pointer" @click="search">
          <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-mail" width="18" height="18"
            viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round"
            stroke-linejoin="round">
            <path
              d="M21.53 20.47l-3.66-3.66C19.195 15.24 20 13.214 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c2.215 0 4.24-.804 5.808-2.13l3.66 3.66c.147.146.34.22.53.22s.385-.073.53-.22c.295-.293.295-.767.002-1.06zM3.5 11c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5-3.365 7.5-7.5 7.5-7.5-3.365-7.5-7.5z">
            </path>
          </svg>
        </div>
        <input
          class="w-full bg-gray-100 dark:bg-dim-400 border-none dark:border-dim-400 text-gray-900 dark:text-white focus:outline-none font-normal h-9 flex items-center pr-4 pl-12 text-sm rounded-lg border"
          placeholder="نام، عنوان، موضوع..." v-model="searchBox" @keyup.enter="search" @input="filterBlogs" />
      </div>
      <div v-if="searchBox && filteredBlogs.length > 0"
        class="bg-gray-50 dark:bg-dim-700 rounded-2xl m-2 hidden xs:block">
        <h1 class="text-gray-900 dark:text-white text-md p-3 border-s border-gray-200 dark:border-gray-700">نتایج جستجو
        </h1>
        <ol class="relative border-s border-gray-200 dark:border-gray-700 h-96 overflow-scroll no-scrollbar-style">
          <li class="mb-1 ms-4 cursor-pointer p-2" v-for="item in filteredBlogs" :key="item.id"
            @click.prevent="blogRoute(item, $event)">
            <div
              class="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -start-1.5 border border-white dark:border-gray-900 dark:bg-gray-700">
            </div>
            <time class="mb-1 text-sm font-normal leading-none text-gray-400 dark:text-gray-500"> {{
              item.createdDateLocal }} </time>
            <h3 class="text-md text-gray-900 dark:text-white line-clamp-1">{{ item.title }}</h3>
            <p class="mb-1 text-base font-normal text-gray-500 dark:text-gray-400 line-clamp-2">{{ item.shortDescription
            }}</p>
          </li>
        </ol>
      </div>

      <div class="bg-gray-50 dark:bg-dim-700 rounded-2xl m-2 max:sm:hidden">
        <h1 class="text-gray-900 dark:text-white text-md p-3 flex items-center gap-2">
          <span class="relative flex h-3 w-3">
            <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
            <span class="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
          </span>
          جدیدترین رسانه
        </h1>
        <video ref="videoPlayer" class="video-js vjs-default-skin" controls width="640" height="264" data-setup="{}">
          <source src="@/assets/videos/sample.mp4" type="video/mp4" />
          <p class="vjs-no-js">برای مشاهده این ویدیو، جاوا اسکریپت را فعال کنید.</p>
        </video>
      </div>

      <div class="bg-gray-50 dark:bg-dim-700 rounded-2xl m-2">
        <h1 class="text-gray-900 dark:text-white text-md p-3">برگزیده ها
        </h1>

        <ol class="relative h-96 overflow-scroll no-scrollbar-style">
          <li class="mb-1 cursor-pointer p-2" v-for="item in blogs" :key="item.id"
            @click.prevent="blogRoute(item, $event)">
            <time class="mb-1 text-sm font-normal leading-none text-gray-400 dark:text-gray-500"> {{
              item.createdDateLocal }} </time>
            <h3 class="text-md text-gray-900 dark:text-white line-clamp-1">{{ item.title }}</h3>
            <p class="mb-1 text-base font-normal text-gray-500 dark:text-gray-400 line-clamp-2">{{ item.shortDescription
            }}</p>
          </li>
        </ol>
      </div>

      <footer>
        <ul class="text-xs text-gray-500 my-4 mx-2">
          <li class="inline-block mx-2">
            <router-link to="/fa/aboutus" class="hover:underline">About Us</router-link>
          </li>
          <li class="inline-block mx-2">
            <router-link to="/fa/contactus" class="hover:underline">Contact Us</router-link>
          </li>
          <li class="inline-block mx-2">© 2025 RefaheMelli, Inc.</li>
        </ul>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import label from "@/plugins/StaticLabels.js";
import alert from "@/plugins/AlertMessages.js";
import videojs from "video.js";
import "video.js/dist/video-js.css";
export default {
  name: "TheSeccoundAside",
  data() {
    return {
      searchBox: null,
      label,
      alert,
      scrollContainer: null,
      isOpen: true,
      player: null,
      filteredBlogs: [],
    };
  },
  computed: {
    ...mapGetters({
      blogs: "dashboardX/blogs",
    }),
    routeName() {
      return this.$route.name;
    },
  },
  methods: {
    blogPage(event) {
      let language = localStorage.getItem("languageId");
      if (event.ctrlKey == true) {
        if (language == 1) {
          const routeData = this.$router.resolve({ name: "FarsiBlogs" });
          window.open(routeData.href, "_blank").focus();
        } else if (language == 2) {
          const routeData = this.$router.resolve({ name: "ArabicBlogs" });
          window.open(routeData.href, "_blank").focus();
        }
      } else {
        if (language == 1) {
          this.$router.push({ name: "FarsiBlogs" });
        } else if (language == 2) {
          this.$router.push({ name: "ArabicBlogs" });
        }
      }
    },
    blogRoute(item, event) {
      let language = localStorage.getItem("languageId");
      const routeName = item.title.split(" ").join("-");
      if (event.ctrlKey == true) {
        if (language == 1) {
          const routeData = this.$router.resolve({
            name: "FarsiBlog",
            params: { id: item.id, title: routeName },
          });
          window.open(routeData.href, "_blank").focus();
        } else if (language == 2) {
          const routeData = this.$router.resolve({
            name: "ArabicBlog",
            params: { id: item.id, title: routeName },
          });
          window.open(routeData.href, "_blank").focus();
        }
      } else {
        if (language == 1) {
          this.$router.push({
            name: "FarsiBlog",
            params: { id: item.id, title: routeName },
          });
        } else if (language == 2) {
          this.$router.push({
            name: "ArabicBlog",
            params: { id: item.id, title: routeName },
          });
        }
      }
    },
    reloadData() {
      let payload = "pageSize=10";
      let language = localStorage.getItem("languageId");
      if (language) {
        payload += "&languageId=" + Number(localStorage.getItem("languageId"));
      }
      this.$store.dispatch("dashboardX/getBlogs", payload);
    },
    search() {
      let language = localStorage.getItem("languageId");
      const routeName = language == 1 ? "FarsiSearch" : "ArabicSearch";
      this.$router.push({
        name: routeName,
        query: { filter: this.searchBox },
      });
      this.searchBox = "";
      this.filteredBlogs = [];
    },
    filterBlogs() {
      this.filteredBlogs = this.blogs.filter((blog) => blog.title.includes(this.searchBox)).slice(0, 10);
    },
  },
  beforeCreate() {
    const routePath = this.$route.path;
    const firstThreeLetters = routePath.slice(0, 3);
    if (firstThreeLetters === "/fa") {
      localStorage.setItem("languageId", 1);
    } else if (firstThreeLetters === "/ar") {
      localStorage.setItem("languageId", 2);
    }
  },
  mounted() {
    let payload = "pageSize=10";
    let language = localStorage.getItem("languageId");
    if (language) {
      payload += "&languageId=" + Number(localStorage.getItem("languageId"));
    }
    this.$store.dispatch("dashboardX/getBlogs", payload);
    this.player = videojs(this.$refs.videoPlayer);
  },
  beforeUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>

<style scoped>
.video-js {
  width: 100%;
  height: 200px;
}

video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
